import TargetPositionsField from './TargetPositionsField.component';

export default TargetPositionsField;